import moment from "moment";
import { FC } from "react";
import { useHistory } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { INoticeItem } from "../../models/boardNotice.model";
import { createAlarm, getHeaderAlarmNotices } from "../../api/alarm.api";
import { RootState } from "../../store/rootReducer";
import { useSelector } from "react-redux";

interface IProps {
  data: INoticeItem;
  execute: any;
}

const Notice: FC<IProps> = ({
  data,
  execute
}) => {
  const history = useHistory();
  const { t, i18n } = useTranslation();
  const { auth } = useSelector((state: RootState) => state.auth);
  
  const handleClick = async () => {

    await createAlarm({
      memberCode: auth.memberCode,
      alarmType: 'NT',
      targetCode: data.noticeCode
    })

    await execute(getHeaderAlarmNotices({
      pageNo: 1,
      perPage: 999999999,
      srtDate: moment().subtract(2, 'month').format('YYYYMMDD'),
      endDate: moment().add(1, 'days').format('YYYYMMDD'),
      memberCode: auth.memberCode
    }));
    
    history.push(`/board/notice/${data.noticeCode}`);
  }

  return (
    <dd>
      <span className='badge-text'>{t('common.layout.14')}</span>
      <a href='#' className='tit' onClick={handleClick}>{data.title}</a>
    </dd>
  );
}

export default Notice;
